import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { Globals } from 'app/_globals';
import { CustomBuilderService } from '../../../_services/custom-bulider.service';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-single-builder-stage',
    templateUrl: './single-builder-stage.component.html',
    styleUrls: ['./single-builder-stage.component.css']
})
export class SingleCustomBuilderStageComponent implements OnInit {

    tabitems: any = [];

    customBuilderId: any;
    selectedCustomBuilder: any;
    builderSteps: any[] = [];

    role: any;
    routeRole: any;

    createBuilderStepForm: FormGroup;
    createBuilderStepModal = false;

    editBuilderStepForm: FormGroup;

    selectedBuilderStep: any = null;
    selectedBuilderStepItems: any[] = [];

    createBuilderStepItemForm: FormGroup;
    createBuilderStepItemModal = false;

    editBuilderStepItemForm: FormGroup;
    editBuilderStepItemModal = false;
    selectedBuilderStepItem: any;

    constructor(
        fb: FormBuilder,
        public activatedRoute: ActivatedRoute,
        public loader: LoadingBarService,
        public notificationService: NotificationService,
        public globals: Globals,
        public _customBuilderService: CustomBuilderService,
        public confirmationService: ConfirmationService,
        public router: Router
    ) {
        // Get Patient id from params
        this.activatedRoute.params.subscribe((params: Params) => {
            this.customBuilderId = params.id;
        });

        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;

        this.tabitems = [
            { path: '/' + this.routeRole + '/custom-builders/', title: 'All Builders', class: 'back-link' },
            { path: '/' + this.routeRole + '/custom-builders/' + this.customBuilderId + '/details', title: 'Details' },
            { path: '/' + this.routeRole + '/custom-builders/' + this.customBuilderId + '/steps', title: 'Steps' },
            {
                path: '/' + this.routeRole + '/custom-builders/' + this.customBuilderId + '/images',
                title: 'Images',
              },
        ];

        this.createBuilderStepForm = fb.group({
            amountFree: new FormControl(),
            description: new FormControl(),
            maximum: new FormControl(),
            minimum: new FormControl(),
            multiple: new FormControl(false),
            name: new FormControl(),
            order: new FormControl()
        });

        this.editBuilderStepForm = fb.group({
            amountFree: new FormControl(),
            description: new FormControl(),
            maximum: new FormControl(),
            minimum: new FormControl(),
            multiple: new FormControl(),
            name: new FormControl(),
            order: new FormControl()
        })

        this.createBuilderStepItemForm = fb.group({
            name: new FormControl(),
            description: new FormControl(),
            price: new FormControl(),
            extraPrice: new FormControl()
        });

        this.editBuilderStepItemForm = fb.group({
            name: new FormControl(),
            description: new FormControl(),
            price: new FormControl(),
            extraPrice: new FormControl()
        })

    }

    ngOnInit() {
        this.getCustomBuilder(this.customBuilderId);
        this.getAllBuilderSteps(this.customBuilderId);
    }

    // Get Custom Builder by id
    public getCustomBuilder(id) {
        this._customBuilderService.getBuilderById(id)
            .subscribe((data: any) => {
                // console.log(data);
                this.selectedCustomBuilder = data;
            });
    }

    // Get all builder steps
    public getAllBuilderSteps(id) {
        this._customBuilderService.getAllBuilderSteps(id)
            .subscribe((data: any) => {
                // console.log(data);
                this.builderSteps = data;
            });
    }

    // Toggle create step modal
    public toggleAddStepModal() {
        this.createBuilderStepModal = !this.createBuilderStepModal;
    }

    public onCreateBuilderStepFormSubmit() {
        const values = this.createBuilderStepForm.value;
        const body = {
            amountFree: values.amountFree,
            description: values.description,
            maximum: values.maximum,
            minimum: values.minimum,
            multiple: values.multiple,
            name: values.name,
            order: values.order
        };
        this._customBuilderService.createBuilderStep(this.customBuilderId, body)
            .subscribe((data: any) => {
                // console.log(data);
                this.getAllBuilderSteps(this.customBuilderId);
                this.createBuilderStepForm.reset();
                this.toggleAddStepModal();
                this.notificationService.notify(
                    'success',
                    'Builder Step Created',
                    'Builder step has successfully been created',
                    'top',
                    'right');
            })
    }

    // Handle Back to Builder Steps functionality
    public backToBuilderSteps() {
        this.selectedBuilderStep = null;
        this.getAllBuilderSteps(this.customBuilderId);
    }

    // BUILDER STEP ITEMS
    public onRowSelect(event) {
        this.selectedBuilderStep = event.data;
        // console.log(this.selectedBuilderStep);
        this.editBuilderStepForm.patchValue({
            amountFree: event.data.amountFree,
            description: event.data.description,
            maximum: event.data.maximum,
            minimum: event.data.minimum,
            multiple: event.data.multiple,
            name: event.data.name,
            order: event.data.order
        });
        // console.log(this.editBuilderStepForm.value);
        this.getAllBuilderStepItems(this.selectedBuilderStep.id);
    }

    // Edit Builder Step
    public onEditBuilderStepFormSubmit() {
        const values = this.editBuilderStepForm.value;
        const body = {
            amountFree: values.amountFree,
            description: values.description,
            maximum: values.maximum,
            minimum: values.minimum,
            multiple: values.multiple,
            name: values.name,
            order: values.order,
            id: this.selectedBuilderStep.id
        };
        // console.log(body);
        this._customBuilderService.editBuilderStep(body)
            .subscribe((data: any) => {
                this.notificationService.notify(
                    'success',
                    'Builder Step Updated',
                    'Builder Step has successfully been updated',
                    'top',
                    'right');
            })
    }

    public getAllBuilderStepItems(id) {
        this._customBuilderService.getAllBuilderStepItemsByBuilderStep(id)
            .subscribe((data: any) => {
                this.selectedBuilderStepItems = data;
            })
    }

    public toggleAddStepItemModal() {
        this.createBuilderStepItemModal = !this.createBuilderStepItemModal;
    }

    public onCreateBuilderStepItemFormSubmit() {
        // console.log('Step ID ', this.selectedBuilderStep.id);
        const values = this.createBuilderStepItemForm.value;
        const body = {
            name: values.name,
            description: values.description,
            price: values.price,
            extraPrice: values.extraPrice
        };
        this._customBuilderService.createBuilderStepItem(this.selectedBuilderStep.id, body)
            .subscribe((data: any) => {
                // console.log(data);
                this.getAllBuilderStepItems(this.selectedBuilderStep.id);
                this.createBuilderStepItemForm.reset();
                this.toggleAddStepItemModal();
                this.notificationService.notify(
                    'success',
                    'Builder Step Item Created',
                    'Builder Step Item has successfully been created',
                    'top',
                    'right');
            })
    }

    // On Row Selct Builder Step ITEM
    public onRowSelectItem(event) {
        // console.log(event);
        this.selectedBuilderStepItem = event.data;
        this.editBuilderStepItemForm.patchValue({
            name: event.data.name,
            description: event.data.description,
            price: event.data.price,
            extraPrice: event.data.extraPrice
        });
        this.toggleEditBuilderStepItemModal();
    }

    public toggleEditBuilderStepItemModal() {
        this.editBuilderStepItemModal = !this.editBuilderStepItemModal;
    }

    public onEditBuilderStepItemFormSubmit() {
        const values = this.editBuilderStepItemForm.value;
        const body = {
            name: values.name,
            description: values.description,
            price: values.price,
            extraPrice: values.extraPrice,
            id: this.selectedBuilderStepItem.id
        };
        this._customBuilderService.editBuilderStepItem(body)
            .subscribe((data: any) => {
                // console.log(data);
                this.toggleEditBuilderStepItemModal();
                this.editBuilderStepItemForm.reset();
                this.getAllBuilderStepItems(this.selectedBuilderStep.id);
                this.notificationService.notify(
                    'success',
                    'Builder Step Item Updated',
                    'Builder Step Item has successfully been updated',
                    'top',
                    'right');
            })
    }

    deleteBuilderComponent(component, type) {
        // console.log('Delete Component - ', component);
        if (type === 'stepItem') {
            this.editBuilderStepItemModal = false;
        }
        this.confirmationService.confirm({
            message: 'Are you sure that you want to delete this ' + type + '?',
            accept: () => {
                if (type === 'stepItem') {
                    this._customBuilderService.deleteBuilderStepItem(component.id)
                        .subscribe((data: any) => {
                            this.notificationService.notify(
                                'success',
                                'Builder Step Item Deleted',
                                'Builder Step Item has successfully been deleted',
                                'top',
                                'right');
                            this.getAllBuilderStepItems(this.selectedBuilderStep.id);
                        });
                } else {
                    this._customBuilderService.deleteBuilderStep(component.id)
                        .subscribe((data: any) => {
                            this.notificationService.notify(
                                'success',
                                'Builder Step Deleted',
                                'Builder Step has successfully been deleted',
                                'top',
                                'right');
                            this.backToBuilderSteps();
                        });
                }
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/custom-builders/single-builder/single-builder-stages/single-builder-stage.component.ts